export enum UBXAlign {
    Start = 'fs',
    Center = 'c',
    End = 'fe',
}
